// extracted by mini-css-extract-plugin
module.exports = {"backgroundMain":"Caisse_backgroundMain__2-z9S","lineCaisseMode":"Caisse_lineCaisseMode__2Om8k","bigButton":"Caisse_bigButton__3kdua"};